export const itemTypes = {
	item: 'item',
	folder: 'folder'
};
